import { LaString, LoString } from "maven-lib/dist/consts";
import { CrfItemIdSpec, EcoaImgSourceSpec, EcoaImgUrlSpec, EcoaQuestionnaireConditionalSpec } from "maven-lib/dist/consts/edc/crf";
import { StudyCaptureData } from "maven-lib/dist/dto/entity/studyCapture";
import { MvnLanguage } from "@maven-msg/lib/Message";

export const isEcoaImgUrlSpec = (spec: EcoaImgSourceSpec): spec is EcoaImgUrlSpec => "url" in spec;

export const isConditionalMatched = (condition: EcoaQuestionnaireConditionalSpec, captures: Array<StudyCaptureData>): boolean => {
  if ("expr" in condition) {
    for (const subExpr of condition.expr) {
      const isSubMatched = isConditionalMatched(subExpr, captures);
      if (condition.operator === "AND") {
        if (!isSubMatched) return false;
      } else if (condition.operator === "OR") {
        if (isSubMatched) return true;
      } else {
        throw new Error(`Invalid Usage, Not supported operator. (condition: ${condition})`);
      }
    }

    return condition.operator === "AND";
  } else {
    const left = ((left: Omit<CrfItemIdSpec, "groupId">) => {
      const found = captures.find(
        ({ id }) =>
          id.folderId === left.folderId &&
          id.visitId === left.visitId &&
          id.visitSeq === left.visitSeq &&
          id.crfPageId === left.crfPageId &&
          id.crfPageSeq === left.crfPageSeq &&
          id.sectionId === left.sectionId &&
          id.itemId === left.itemId &&
          id.itemSeq === left.itemSeq
      );

      if (!found) {
        return null;
      }

      return found.val.dbVal;
    })(condition.left);

    switch (condition.operator) {
      case "!=":
        return left !== condition.right;
      case "=":
        return left === condition.right;
      default:
        throw new Error(`Invalid Usage, Not supported operator. (condition: ${condition})`);
    }
  }
};

export const getPreScreeningBaseUrl = (studyId: bigint, siteId?: bigint): string => {
  return `/${studyId}${siteId ? `/sites/${siteId}` : ""}`;
};

export const getLaStringValue = (value: LaString | null, lang?: MvnLanguage | null): string | null | undefined => {
  const convertLang = lang?.toLocaleLowerCase() as keyof LoString;

  if (!value) return null;

  if (typeof value === "string") return value;

  if (!value[convertLang]) return value["en"];

  return value[convertLang || "en"];
};
